// extracted by mini-css-extract-plugin
module.exports = {"Signup":"la_a"};